












import { Component, Prop, Vue, Watch } from 'vue-property-decorator';


@Component
export default class GroupButton extends Vue {
    @Prop() private options!: any[];
    @Prop() private value!: any;


    private optionSelected: any = {};


    private created() {
        this.optionSelected = this.value;
    }


    private selectOption(option: any) {
        this.optionSelected = option;
        this.$emit('option-selected', option);
        this.$emit('input', option);
    }

    private isOptionSelected(option: any) {
        return this.optionSelected && this.optionSelected.id === option.id;
    }
}
